import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { CustomError } from "@/utils/errors";

import {
  deleteFeedback,
  DeleteFeedbackPayload,
  FeedbackPayload,
  FeedbackRating,
  postFeedback
} from "./feedbackApi";

export const usePostFeedbackMutation = <TContext = unknown>(
  options?: UseMutationOptions<unknown, CustomError, FeedbackPayload, TContext>
) => {
  return useMutation({
    mutationFn: (payload: FeedbackPayload) => postFeedback(payload),
    ...options
  });
};

export const useDeleteFeedbackMutation = <TContext = unknown>(
  options?: UseMutationOptions<
    unknown,
    CustomError,
    DeleteFeedbackPayload,
    TContext
  >
) => {
  return useMutation({
    mutationFn: (payload: DeleteFeedbackPayload) => deleteFeedback(payload),
    ...options
  });
};

export interface UpsertFeedbackRatingVariables {
  payload: FeedbackPayload;
  priorRating: FeedbackRating | null;
}

export const useUpsertFeedbackRatingMutation = <TContext = unknown>(
  options?: UseMutationOptions<
    unknown,
    CustomError,
    UpsertFeedbackRatingVariables,
    TContext
  >
) => {
  return useMutation({
    mutationFn: async ({
      payload,
      priorRating
    }: UpsertFeedbackRatingVariables) => {
      if (priorRating && priorRating !== payload.rating) {
        await deleteFeedback({
          reference_id: payload.reference_id,
          reference_type: payload.reference_type
        });
      }
      return postFeedback(payload);
    },
    ...options
  });
};
